export default "__VITE_ASSET__BmApwvxu__"